// extracted by mini-css-extract-plugin
module.exports =  {"arrow":"_33974c2b58--arrow--ICHk1"};